import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import ViewProfileLayer from '../components/ViewProfileLayer';
import { useFetch } from '../hook/useFecth';

const ViewProfilePage = () => {
    const { data, mutate, isLoading } = useFetch(`profile`);

    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="Perfil" icon="solar:user-circle-outline" />

            {/* ViewProfileLayer */}
            <ViewProfileLayer data={data} mutate={mutate} />
        </>
    );
};

export default ViewProfilePage;
